module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7c74d1187f403ff0ce14c54989f8cb09.png";